import { render, staticRenderFns } from "./SectionServices.vue?vue&type=template&id=76db1bbc&scoped=true"
import script from "./SectionServices.vue?vue&type=script&lang=js"
export * from "./SectionServices.vue?vue&type=script&lang=js"
import style0 from "./SectionServices.vue?vue&type=style&index=0&id=76db1bbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76db1bbc",
  null
  
)

export default component.exports